export default {
  ratePlanType: {
    STANDARD: '标准',
    BAR: '最优可订房价',
    CORPORATE: '企业',
    MEMBER: '会员',
    PACKAGE: '套餐',
    PROMOTIONAL: '促销',
    OTA: 'OTA',
    WHOLESALE: '批发',
    NEGOTIATED: '协议价',
    MIXED: '混合房价',
  },
} as const;
